import { matchers } from '../http-request';
import { actions } from './invite.actions';

const { isRequestResultSuccessFor } = matchers.core;

export const isReadSuccess = isRequestResultSuccessFor(actions.isRead);
